const initialState = {
  data: [],
  currentTab: "Conflict Resolution Program"
};

const dataReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'UPLOAD_DATA':
        return {
          ...state,
          data: action.payload,
        };
        case 'UPLOAD_FILE':
          return {
            ...state,
            file: action.payload,
          };
        case 'UPDATE_TAB':
          return {
            ...state,
            currentTab: action.payload,
          }
      default:
        return state;
    }
  };

export default dataReducer;
